<div class="container-group" *ngIf="packagesInRoute">
    <div class="title">
        {{'SHARED.ROUTE.PACKAGE.ORDER.TITLE' | translate}}
    </div>

    <button-link variant="forward" class="line right" *ngIf="!readonly && !onlyvieworder && !showvieworder"
        (linkClick)="showvieworder=true">{{
        'PACKAGE.ACTIONS.SHOWVIEWORDER.CAPTION' | translate}}</button-link>
    <button-link variant="forward" class="line right" *ngIf="!readonly && !onlyvieworder && showvieworder"
        (linkClick)="showvieworder=false">{{
        'PACKAGE.ACTIONS.HIDEVIEWORDER.CAPTION' | translate}}</button-link>

    <div class="linia bar baroptions" *ngIf="!readonly && !onlyvieworder && !showvieworder">
        <options class="slim mixed-text-icon" [optionstrip]="optionsOrder" (clickOption)="onClickOptionOrder($event)">
        </options>
    </div>
    <div class="list">

        <div cdkDropList (cdkDropListDropped)="drop($event)"
            [cdkDropListDisabled]="readonly || (!onlyvieworder && !showvieworder)">
            <div class="item-container" [ngClass]="{'draggable': !readonly && (onlyvieworder || showvieworder)}"
                *ngFor="let item of packagesInRoute | sortBy:getOrder()" cdkDrag
                [cdkDragDisabled]="readonly || (!onlyvieworder && !showvieworder)">

                <shared-shipment-package-card [package]="item"
                    [isActiveRoutes]="'true'" (click)="selectPackage(item)"
                    [ngClass]="{'selected': selectedPackage!=null && item.packageId==selectedPackage.packageId}">
                </shared-shipment-package-card>

                <div class="buttons" *ngIf="!readonly && (showvieworder || onlyvieworder)">
                    <button class="move-shipment move-up" (click)="movePackageUp(item)">
                        <i class="fa fa-chevron-up"></i>
                        <span>
                            {{ "PACKAGE.ACTIONS.MOVEUP.SLIM" | translate }}
                        </span>
                    </button>
                    <button class="move-shipment move-down" (click)="movePackageDown(item)">
                        <i class="fa fa-chevron-down"></i>
                        <span>
                            {{ "PACKAGE.ACTIONS.MOVEDOWN.SLIM" | translate }}
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>